import { render, staticRenderFns } from "./WorkShiftInfo.vue?vue&type=template&id=512a4406&scoped=true&"
import script from "./WorkShiftInfo.vue?vue&type=script&lang=js&"
export * from "./WorkShiftInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512a4406",
  null
  
)

export default component.exports